/**
 * Whether a rarity band is allowed to be a colour, for every skin and every mode at once.
 *
 * Both pickup elements already draw a band on three channels: a count of marks, the band's own
 * word, and a hue derived from where the rank sits on the scale. This is the switch that removes
 * the third one, and the reason it exists is that a channel nobody can check is a channel that
 * quietly becomes the only one. With the colour gone the marks and the word are all that is left,
 * so a build where the rank stopped reaching them is a build a screenshot shows.
 *
 * It is not only a test. Around one man in twelve cannot separate the ramp's own ends, and a
 * violet-for-exotic that reads as a slightly different bone is a HUD saying nothing in colour and
 * saying it loudly.
 *
 * The frame reads this per tick and puts the answer on the layer as one class, the way it puts the
 * size on as one custom property. Every element's sheet then states what it looks like under that
 * class, because what a band should fall back to is a question about that element's own drawing.
 *
 * On by default. Colour is a fast channel for the players who have it, and this is the knob for the
 * players who do not rather than a decision made on their behalf for everybody.
 */

export const DEFAULT_RARITY_COLOUR = true;

let coloured = DEFAULT_RARITY_COLOUR;

export function rarityColour(): boolean {
  return coloured;
}

export function setRarityColour(on: boolean): void {
  coloured = on;
}
